import { deleteMarketWageUnitPrice } from "@erp/shared/api/generated/wrappers/backdata";
import { patchMarketWageUnitPrice, } from "@erp/shared/api/generated/wrappers/backdata";
import { postMarketWageUnitPrice, } from "@erp/shared/api/generated/wrappers/backdata";
import { useInvalidateQueries } from "@erp/shared/composables/useInvalidateQueries";
import { queries } from "@erp/shared/queries";
import { showAlert } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { useMutation, useQuery } from "@tanstack/vue-query";
export const useMarketWageUnitPriceAction = () => {
    const { invalidateQueries } = useInvalidateQueries();
    const readQuery = useQuery(queries.laborCost.marketWageUnitPrice());
    const createMutation = useMutation({
        mutationFn: async (body) => await postMarketWageUnitPrice(body),
        onSuccess: () => {
            showAlert("시중노임단가 정보 등록 완료", "완료");
            invalidateQueries([queries.laborCost.marketWageUnitPrice().queryKey]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "시중노임단가 정보 등록 실패");
        },
    });
    const updateMutation = useMutation({
        mutationFn: async ({ id, body, }) => await patchMarketWageUnitPrice(id, body),
        onSuccess: () => {
            showAlert("시중노임단가 정보 수정 완료", "완료");
            invalidateQueries([queries.laborCost.marketWageUnitPrice().queryKey]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "시중노임단가 정보 수정 실패");
        },
    });
    const deleteMutation = useMutation({
        mutationFn: async (id) => await deleteMarketWageUnitPrice(id),
        onSuccess: () => {
            showAlert("시중노임단가 정보 삭제 완료", "완료");
            invalidateQueries([queries.laborCost.marketWageUnitPrice().queryKey]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "시중노임단가 정보 삭제 실패");
        },
    });
    return {
        readQuery,
        createMutation,
        updateMutation,
        deleteMutation,
    };
};
